import { render } from "./InfoCard.vue?vue&type=template&id=076511aa&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=076511aa&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-076511aa"]])

export default __exports__